import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {RemarkTypeService} from '../../apiModule';
import {IndexEntityService} from '../../apiModule1';

export const indexResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: IndexEntityService = inject(IndexEntityService)) => {
  return service.apiIndexGet({}, 'body', false, {transferCache: false});
};
